// Invisible jump target for a block's "Anchor link" (Drupal returns it as
// `anchor` on every block: the custom anchor text or the block ID, or null
// when the checkbox is off). Rendered as an empty marker right before the
// block instead of wrapping it, so the block's own markup and the parent's
// CSS (child selectors, flex/grid) stay exactly as they are.
export default function BlockAnchor({ anchor }) {
  if (!anchor) {
    return null;
  }
  return <div id={String(anchor)} className="block-anchor" aria-hidden="true" />;
}
